import React from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Hidden from '@material-ui/core/Hidden';
import Breadcrumb from '@common_breadcrumb';
import { makeStyles } from '@material-ui/core/styles';
import RightToolbar from '@modules/theme/layout/components/rightToolbar';
import { miniDrawerWidth, drawerWidth } from '@modules/theme/layout/helpers';

const useStyles = makeStyles((theme) => ({
    swiftOmsLogo: {
        padding: '12px 24px 12px 0px',
        borderRight: '1px solid #dde1ec',
        '& img': { height: 36, verticalAlign: 'middle' },
    },
    appBarShiftDesktop: {
        backgroundColor: '#fff',
        position: 'fixed',
        width: '100vw',
        height: 64,
    },
    appBar: {
        backgroundImage: 'linear-gradient(184deg, #D49AEB 50%, #F9C8C1 100%)',
        // opacity: '0.8',
        color: '#FFFFFF',
        boxShadow: 'none',
        marginLeft: miniDrawerWidth,
        width: `calc(100% - ${miniDrawerWidth + 1}px)`,
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        [theme.breakpoints.down('xs')]: {
            marginLeft: 0,
            width: '100%',
        },
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth + 1}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        '&.fullWidth': {
            width: '100%',
        },
    },
    togleMenuButton: {
        marginRight: -6,
        width: 24,
        height: 24,
        transform: 'translateX(-24px)',
        [theme.breakpoints.down('xs')]: {
            marginRight: 0,
            transform: 'translate(0px, -2px)',
        },
    },
    togleMenuIcon: {
        fontSize: 27,
        color: '#bE1f93',
        borderRadius: '3px',
        background: '#fff',
        boxShadow: '0px 3px 6px #DDE1EC',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    swiftOmsLogoDesktop: {
        cursor: 'pointer',
        marginBottom: 0,
        paddingBottom: 10,
        justifyContent: 'center',
        '& img': {
            height: 45,
            marginTop: 10,
        },
    },
}));

const Header = ({
    breadcrumbData, open, setOpen, notificationRes, storeLogo, setLoadLang, hideSidebar,
}) => {
    const classes = useStyles();

    const HeaderMobile = () => (
        <AppBar position="fixed" className={clsx(classes.appBar)}>
            <Toolbar>
                <div className={clsx(classes.swiftOmsLogo, open ? 'open' : 'close')}>
                    <img alt="" src={(storeLogo && storeLogo.favicon) || '/assets/img/swiftoms_logo_collapsed.png'} />
                </div>
                {!hideSidebar
                    && (
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={() => setOpen(!open)}
                            className={clsx(classes.togleMenuButton)}
                        >
                            <ChevronRightIcon className={classes.togleMenuIcon} />
                        </IconButton>
                    )}
                <RightToolbar notificationRes={notificationRes} setLoadLang={setLoadLang} />
            </Toolbar>
        </AppBar>
    );

    const HeaderDesktop = () => (
        <AppBar
            position="fixed"
            className={clsx(classes.appBar, {
                [classes.appBarShift]: open,
            }, hideSidebar && 'fullWidth')}
        >
            <Toolbar>
                {hideSidebar
                    ? (
                        <Link href="/">
                            <a>
                                <div className={clsx(classes.toolbar, classes.swiftOmsLogoDesktop, open ? 'open' : 'close')}>
                                    <img
                                        alt=""
                                        src={open ? storeLogo?.logo || '/assets/img/swiftoms_logo_expanded.png'
                                            : storeLogo?.favicon || '/assets/img/swiftoms_logo_collapsed.png'}
                                    />
                                </div>
                            </a>
                        </Link>
                    ) : (
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={() => setOpen(!open)}
                            className={clsx(classes.togleMenuButton)}
                        >
                            {open ? <ChevronLeftIcon className={classes.togleMenuIcon} /> : <ChevronRightIcon className={classes.togleMenuIcon} />}
                        </IconButton>

                    )}
                <Hidden smDown={open} implementation="css">
                    <Breadcrumb data={breadcrumbData} />
                </Hidden>
                <RightToolbar notificationRes={notificationRes} setLoadLang={setLoadLang} />
            </Toolbar>
        </AppBar>
    );

    return (
        <>
            <Hidden smUp implementation="css">
                {HeaderMobile()}
            </Hidden>
            <Hidden xsDown implementation="css">
                <div className={classes.appBarShiftDesktop} />
                {HeaderDesktop()}
            </Hidden>
        </>
    );
};

export default Header;
